function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { registerDestructor } from "@ember/destroyable";
import DmpConnectJSAuthenticationContextAdapter from "../../contexts/dmpconnect-js/authentication-context-adapter";
import { CnamManagerAdapter } from "../cnam-manager-adapter";
import DmpConnectJSCardReaderAdapter from "./card-reader-adapter";
import DmpConnectJSDmpAdapter from "./dmp-adapter";
import DmpConnect from "./dmp-connect";
import DmpConnectJSInsiAdapter from "./insi-adapter";
import PinCodeManager from "./pin-code-manager";
export default class DmpConnectJSCnamManagerAdapter extends CnamManagerAdapter {
  constructor(medic, store, accessToken, fetcher, requestManager, featuresService) {
    super();
    _defineProperty(this, "name", "dmpconnect-js");
    this.pinCodeManager = new PinCodeManager(medic);
    this.dmpConnect = new DmpConnect(this.pinCodeManager, medic, accessToken, featuresService);
    this.cardReaderAdapter = new DmpConnectJSCardReaderAdapter(this.pinCodeManager, this.dmpConnect);
    this.authenticationContext = new DmpConnectJSAuthenticationContextAdapter(this.name, this.pinCodeManager, this.cardReaderAdapter, this.dmpConnect, medic, store, fetcher, requestManager);
    this.dmpAdapter = new DmpConnectJSDmpAdapter(this.dmpConnect, this.cardReaderAdapter, this.authenticationContext, medic, store);
    this.insiAdapter = new DmpConnectJSInsiAdapter(this.dmpConnect, this.authenticationContext);
    this.medic = medic;
    this.requestManager = requestManager;
    registerDestructor(this, async () => {
      await this.dmpConnect.closeSession();
    });
  }
  async onDismiss() {
    await this.dmpAdapter.closeSession();
  }
}